import Component_GlowLayer_22adcf7ecbda01797409ea43e44e1499 from "../../../../content/examples/special-fx/glow-layer/GlowLayer";
import Devtool_GlowLayer_22adcf7ecbda01797409ea43e44e1499 from "!!@devtool/loader!../../../../content/examples/special-fx/glow-layer/GlowLayer";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_GlowLayer_22adcf7ecbda01797409ea43e44e1499,
  Devtool_GlowLayer_22adcf7ecbda01797409ea43e44e1499,
  DevTool,
  React
};